import media from './media.scss';

export default media;
